import { AnnouncementBanner } from "~landing/components/home/announcement-banner";
import { bannerConfig } from "~landing/components/home/banner-config";
import { Benefits } from "~landing/components/home/benefits";
import { Faqs } from "~landing/components/home/faqs";
import { FeatureHighlights } from "~landing/components/home/feature-highlights";
import { Hero } from "~landing/components/home/hero";
import { HowItWorks } from "~landing/components/home/how-it-works";
import { PricingTeaser } from "~landing/components/home/pricing-teaser";
import { StartBuilding } from "~landing/components/home/start-building";
import { Testimonials } from "~landing/components/home/testimonials";
import { UseCases } from "~landing/components/home/use-cases";
import { governmentContent } from "~landing/components/government/content";
import { MarketingPage } from "~landing/components/layout/marketing-page";

export function SolutionsGovernmentView() {
	return (
		<MarketingPage topBanner={<AnnouncementBanner config={bannerConfig} />}>
			<Hero content={governmentContent.hero} />
			<Benefits content={governmentContent.benefits} />
			<UseCases content={governmentContent.useCases} />
			<Testimonials content={governmentContent.testimonials} />
			<HowItWorks content={governmentContent.howItWorks} />
			<Faqs content={governmentContent.faqs} />
			<FeatureHighlights content={governmentContent.featureHighlights} />
			<PricingTeaser content={governmentContent.pricingTeaser} />
			<StartBuilding content={governmentContent.startBuilding} />
		</MarketingPage>
	);
}
